import React, { FC } from 'react';

type Props = {
  classCss: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconArrowDown: FC<Props> = ({ classCss, props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 15"
      className={classCss}
      {...props}
    >
      <polygon
        fillRule="evenodd"
        points="2.832 5 12 14.216 21.168 5 24 7.832 12 19.832 0 7.832"
        transform="translate(0 -5)"
      />
    </svg>
  );
};

export default IconArrowDown;
